import { PlatformRoleEnum, SiteRoleEnum } from 'domains/roleDomain';
import { User } from '../domains/appDomain';
import { OrgTypeEnum } from 'features/Platform/components/OrgAdmin/OrgTypeSelectModal';
import { Organization } from 'domains/orgDomain';

export function canVisitAdminSpace(user: User | null) {
  return user && user.platformRole !== PlatformRoleEnum.NoAdminAccess;
}

export function canVisitStore(user: User | null) {
  return user && user.siteRole !== SiteRoleEnum.NoSiteAccess;
}

export function isBuyer(user?: User | null) {
  return user ? user.siteRole === SiteRoleEnum.Buyer : false;
}

export function isSourcer(user?: User | null) {
  return user ? user.siteRole === SiteRoleEnum.Sourcer : false;
}
export function isSupplier(user?: User | null) {
  return user ? user.siteRole === SiteRoleEnum.Supplier : false;
}

export function isOrgAdmin(user?: User | null) {
  return user
    ? user.platformRole === PlatformRoleEnum.OrganizationAdmin
    : false;
}

export function isSaasOrgAdmin(user?: User | null, org?: Organization | null) {
  return user && org
    ? user.platformRole === PlatformRoleEnum.OrganizationAdmin &&
        (org.orgType === OrgTypeEnum.SAAS ||
          org.orgType === OrgTypeEnum.CUSTOMER)
    : false;
}

export function isSysAdmin(user?: User | null) {
  return user
    ? user.platformRole === PlatformRoleEnum.BackendSystemAdmin
    : false;
}

export function isModeAdmin() {
  return window.location.href.indexOf('mode=admin') === -1;
}

export function canSwitchToSourcer(user: User | null) {
  return user && isSupplier(user) && user.allowSwitchToSourcer;
}

export function canSwitchToSupplier(user: User | null) {
  return user && isSourcer(user) && user.allowSwitchToSupplier;
}

export function needLinkToQuickBooks(user: User | null) {
  return (
    user && user.siteRole !== SiteRoleEnum.Buyer && !user.hasLinkedToQuickBooks
  );
}

export function hasLinkToQuickBooks(user: User | null) {
  return (
    user && user.siteRole !== SiteRoleEnum.Buyer && user.hasLinkedToQuickBooks
  );
}
